import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { ApexCharts, Charts } from "../../../Constant";
import BasicAreaChart from "./BasicAreaChart";
import AreaSpalineChart from "./AreaSpalineChart";
import BarChart from "./BarChart";
import ColumnChart from "./ColumnChart";
import BubbleChart from "./BubbleChart";
import SteplineChart from "./SteplineChart";
import ColumnCharts from "./ColumnCharts";
import PieChart from "./PieChart";
import MixedChart from "./MixedChart";
import CandlestickChart from "./CandlestickChart";
import RadarChart from "./RadarChart";
import RadialBarChart from "./RadialBarChart";
import DonutCharts from "./DonutCharts";

const ApexChartContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={ApexCharts} parent={Charts} title={ApexCharts} />
      <Container fluid>
        <Row>
          <BasicAreaChart />
          <AreaSpalineChart/>
          <BarChart/>
          <ColumnChart/>
          <BubbleChart/>
          <SteplineChart/>
          <ColumnCharts/>
          <PieChart/>
          <DonutCharts/>
          <MixedChart/>
          <CandlestickChart/>
          <RadarChart/>
          <RadialBarChart/>
        </Row>
      </Container>
    </>
  );
};

export default ApexChartContainer;
